export default __webpack_public_path__ + "static/media/eKYC_Result_Pass@2x.59af9022.png";